import { CommandButton, JournalTable, Modal, TableHeader } from "components";
import { Fragment, useContext } from "react";
import { convertNumber, useToggle } from "utils";
import { journalMap } from "../utils";
import moment from "moment";
import { DetailDataContext } from "../contexts";

export function JournalCountAdjusment() {
  const { isActive, toggle } = useToggle(false)

   const detail = useContext(DetailDataContext);
  
  const dataJournal = detail.countdetail.flatMap(i => {
    const amount = i.amount_adjustment ? i.amount_adjustment : "0";
    const inventoryAccount = `${i.coa_inventory_code} ${i.coa_inventory_name}`;
    const coexAccount = `${i.coa_coex_code} ${i.coa_coex_name}`;

    return journalMap(detail.invcount.transaction_date,
      i.product_barcode,
      inventoryAccount,
      coexAccount,
      i.stock_in || 0,
      i.stock_out || 0,
      Number(amount)
    )
  })

  const totalCredit = dataJournal.reduce((prev, curr) => prev + Number(curr.credit), 0);
  const totalDebet = dataJournal.reduce((prev, curr) => prev + Number(curr.debet), 0);

  const dataJournalFill = dataJournal.slice().sort((a, b) => {
    if (a.debet && !b.debet) return -1;
    if (!a.debet && b.debet) return 1;
    return 0;
  })

  return (
    <Fragment>
      <CommandButton actiontype="journal" onClick={toggle} />

      {isActive && (
        <Modal isOpen title="JOURNAL" closeModal={toggle} size="full">
          <Modal.Body>
            <JournalTable>
              <JournalTable.Content>
                <TableHeader>
                  <tr>
                    <th>DATE</th>
                    <th>IDM</th>
                    <th>ACCOUNT</th>
                    <th>DEBET</th>
                    <th>CREDIT</th>
                  </tr>
                </TableHeader>

                <tbody>
                  {dataJournalFill.length > 0 ? dataJournalFill.map((item, index) => (
                    <tr key={index}>
                      <td>{moment(item.date).format("DD/MM/YYYY")}</td>
                      <td>{item.idm}</td>
                      <td>{item.account}</td>
                      <td className="text-right">{item.debet ? convertNumber(item.debet).intoCurrency : 0}</td>
                      <td className="text-right">{item.credit ? convertNumber(item.credit).intoCurrency : 0}</td>
                    </tr>
                  )) : (<tr><td colSpan={5} className="text-center">No Data</td></tr>)}
                </tbody>
              </JournalTable.Content>
              <JournalTable.Amount>
                <tfoot>
                  <tr className="text-xl font-bold">
                    <th className="text-right">TOTAL</th>
                    <th className="text-right">
                      {totalCredit ? convertNumber(totalCredit).intoCurrency : "0"}
                    </th>
                    <th className="text-right">
                      {totalDebet ? convertNumber(totalDebet).intoCurrency : "0"}
                    </th>
                  </tr>
                </tfoot>
              </JournalTable.Amount>
            </JournalTable>
          </Modal.Body>
        </Modal>
      )}
    </Fragment>
  )
}